export const SHOW_VENDOR_DETAILS = 'SHOW_VENDOR_DETAILS';
